var React = require('react');

function IconTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.90356 21.4894L1.70711 13.2929C1.31658 12.9024 0.683418 12.9024 0.292893 13.2929C-0.0976311 13.6835 -0.0976311 14.3166 0.292893 14.7072L9.29289 23.7072C9.71911 24.1334 10.4227 24.0885 10.7913 23.6115L27.7913 1.6115C28.129 1.17448 28.0485 0.546456 27.6114 0.208763C27.1744 -0.12893 26.5464 -0.0484138 26.2087 0.388601L9.90356 21.4894Z","fill":"#0061EE"}));
}

IconTick.defaultProps = {"width":"28","height":"24","viewBox":"0 0 28 24","fill":"none"};

module.exports = IconTick;

IconTick.default = IconTick;
